// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2quTB","name":"Header_name__2D_gW","birthday":"Header_birthday__2WJ9O","skeleton":"Header_skeleton__2uNbk"};